import toCamel from './to-camel';
export default toCamel(' ');
